export default __webpack_public_path__ + "static/media/brainhive.6dc43b0f.svg";